import * as yup from 'yup';

import { allgemeinSchema } from '@/features/Sparten/shared/schema/kfz/notPkw/allgemeinSchema/allgemeinSchema';
import { erstfahrzeugSchema } from '@/features/Sparten/shared/schema/kfz/erstfahrzeugSchema/erstfahrzeugSchema';
import { fahrzeugSchema } from '@/features/Sparten/nutz/schema/fahrzeugSchema/fahrzeugSchema';
import { versicherungsnehmerSchema } from '@/features/Sparten/nutz/schema/versicherungsnehmerSchema/versicherungsnehmerSchema';
import { KASKOTYP } from '@/features/Sparten/shared/types';
import {
  hasFahrerschutzversicherung,
  hasRabattschutzKfzHaftpflicht,
  hasRabattschutzKfzVollkasko,
  hasSfKlasse,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import { baseInputSchema } from '@/features/Sparten/shared/schema/kfz/baseInputSchema';
import { fahrerkreisSchema as kfzFahrerkreisSchema } from '@/features/Sparten/shared/schema/kfz/fahrerkreisSchema/fahrerkreisSchema';

export const nutzSchema = baseInputSchema.concat(
  yup.object({
    allgemein: allgemeinSchema,
    erstfahrzeug: erstfahrzeugSchema,
    fahrerkreis: kfzFahrerkreisSchema,
    fahrzeug: fahrzeugSchema,
    fahrerschutzversicherung: yup
      .boolean()
      .default(false)
      .when({
        is: () => hasFahrerschutzversicherung.value,
        then: yup.boolean().required(),
      }),
    rabattschutzKfzHaftpflicht: yup
      .boolean()
      .default(false)
      .when({
        is: () => hasRabattschutzKfzHaftpflicht.value,
        then: yup.boolean().required(),
      }),
    rabattschutzVollkasko: yup
      .boolean()
      .default(false)
      .when({
        is: () => hasRabattschutzKfzVollkasko.value,
        then: yup.boolean().required(),
      }),
    sfKlasseKH: yup
      .string()
      .default('')
      .when({
        is: () => hasSfKlasse(),
        then: yup.string().required(),
      }),
    sfKlasseVK: yup
      .string()
      .default('')
      .when('kaskoTyp', {
        is: (val: string) => val === KASKOTYP.VOLLKASKO && hasSfKlasse(),
        then: yup.string().required(),
      }),
    versicherungsnehmer: versicherungsnehmerSchema,
  }),
);
